import BurgerMenu from "./BurgerMenu";
import styles from "./Header.module.css";
import Logo from "./Logo";
import Profile from "./Profile";

interface HeaderProps {
  profileHref?: string;
  profileChildren?: React.ReactNode;
  onBurgerMenuClick?: () => void;
  logoHref: string;
}

const Header = ({ profileHref, profileChildren, onBurgerMenuClick, logoHref }: HeaderProps) => {
  return (
    <div className={styles.Header}>
      <BurgerMenu onClick={onBurgerMenuClick} />
      <Logo href={logoHref} />
      {profileChildren && profileHref ? (
        <Profile href={profileHref}>{profileChildren}</Profile>
      ) : (
        <span className={styles.Blank} />
      )}
    </div>
  );
};

export default Header;
